<div class="container">
    <div class="card-form">
        <div class="blue-top"></div>
        <div class="card-section bottom-section">
            <p [class]='{success:!error,danger:error}'>{{ error ? error :success}}</p>
        </div>
    </div>
</div>
